// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.5957 16.9395L17.9395 22.5967L14.4033 19.0605L15.8184 17.6465L17.9395 19.7676L22.1816 15.5254L23.5957 16.9395Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C15.3137 1 18 3.68629 18 7V10H20.5V13.377C19.8799 13.1347 19.2058 13 18.5 13C15.4624 13 13 15.4624 13 18.5C13 19.8298 13.4723 21.049 14.2578 22H3.5V10H6V7C6 3.68629 8.68629 1 12 1ZM9 17H11.5V15H9V17ZM12 3C9.79086 3 8 4.79086 8 7V10H16V7C16 4.79086 14.2091 3 12 3Z"}}]};

const LockCheckedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lock-checked-filled',
    ref,
    icon: element,
  },
));

LockCheckedFilledIcon.displayName = 'LockCheckedFilledIcon';

export default LockCheckedFilledIcon;
